import React from 'react';
import {
  View, Text, StyleSheet, SafeAreaView, TouchableOpacity, Image,
} from 'react-native';
import { ms, s, vs } from '../../../../utils/responsive';
import { useNavigation } from '@react-navigation/native';
import { RootStackNavigationProp } from '../../../../types/navigation';
import { BottomNavBar } from '../../../../components/BottomNavBar';

export const EulogyLockedScreen: React.FC = () => {
  const navigation = useNavigation<RootStackNavigationProp>();

  const handleViewInfoPress = () => {
    navigation.navigate('EulogyData');
  };

  const handleBackPress = () => {
    navigation.navigate('FinalWishesChecklist');
  };

  return (
    <SafeAreaView style={styles.container}>
      <View style={styles.header}>
        <TouchableOpacity
          style={styles.backButton}
          onPress={() => navigation.goBack()}
        >
          <Image
            source={require('../../../../assets/icons/back.png')}
            style={styles.backIcon}
          />
        </TouchableOpacity>
        <Image
          source={require('../../../../assets/logo.png')}
          style={styles.logo}
          resizeMode="contain"
        />
      </View>

      <View style={styles.content}>
        <View style={styles.lockIconContainer}>
          <Image
            source={require('../../../../assets/icons/BlueLock.png')}
            style={styles.lockIcon}
            resizeMode="contain"
          />
          <Text style={styles.lockText}>LOCKED</Text>
        </View>

        <View style={styles.redContainer}>
          <Text style={styles.messageText}>
            You can always change this setting later.
          </Text>
        </View>

        <View style={styles.grayButtonContainer}>
          <TouchableOpacity
            style={[styles.button, styles.orangeButton]}
            onPress={handleViewInfoPress}
          >
            <Text style={styles.buttonText}>View Your Eulogy</Text>
          </TouchableOpacity>

          <TouchableOpacity
            style={[styles.button, styles.greenButton]}
            onPress={handleBackPress}
          >
            <Text style={styles.buttonText}>Back to Task List</Text>
          </TouchableOpacity>
        </View>
      </View>
    </SafeAreaView>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: '#F3F6F8', // Light gray background
  },
  header: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    padding: ms(15),
    paddingTop: ms(15),
    position: 'relative',
  },
  backButton: {
    position: 'absolute',
    left: ms(50),
    top: '50%',
    transform: [{ translateY: -12 }],
    padding: ms(5),
    zIndex: 1,
  },
  backIcon: {
    width: s(24),
    height: s(24),
    tintColor: '#333',
  },
  logo: {
    width: s(80),
    height: s(80),
  },
  content: {
    flex: 1,
    justifyContent: 'space-between',
  },
  lockIconContainer: {
    alignItems: 'center',
    marginTop: ms(20),
  },
  lockIcon: {
    width: s(100),
    height: s(100), // Large lock icon
  },
  lockText: {
    fontSize: ms(24, 0.3),
    fontWeight: 'bold',
    color: '#1C2C4F', // Dark blue text
    marginTop: ms(10),
  },
  redContainer: {
    backgroundColor: '#FF6B6B', // Red message container
    padding: ms(20),
    paddingBottom: ms(80),
    borderTopLeftRadius: ms(30),
    borderTopRightRadius: ms(30),
    position: 'absolute',
    bottom: ms(210),
    left: 0,
    right: 0,
    zIndex: 1,
  },
  messageText: {
    color: '#FFFFFF',
    fontSize: ms(20, 0.3),
    lineHeight: ms(40, 0.3),
    textAlign: 'center',
    paddingHorizontal: ms(25),
  },
  grayButtonContainer: {
    backgroundColor: '#F3F6F8', // Light gray button area
    padding: ms(20),
    paddingTop: ms(30),
    paddingBottom: ms(60),
    borderRadius: ms(30),
    gap: ms(25),
    position: 'absolute',
    bottom: ms(30),
    left: 0,
    right: 0,
    zIndex: 2, // Higher z-index than red container
  },
  button: {
    alignItems: 'center',
    justifyContent: 'center',
    padding: ms(15),
    borderRadius: ms(50),
  },
  buttonText: {
    fontSize: ms(20, 0.3),
    fontWeight: '600',
    color: '#FFFFFF',
    textAlign: 'center',
  },
  orangeButton: {
    backgroundColor: '#FF9F5A', // Orange view button
  },
  greenButton: {
    backgroundColor: '#29BFC0', // Teal back button
  },
});

export default EulogyLockedScreen;
